import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "twin-keyvalue-form"
  }, [!_vm.dense ? _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.keyValue')))]) : !_vm.oneColLayout ? _c('p', {
    staticClass: "text-bold px-0 mx-0 mb-1"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.keyValue')) + "\n  ")]) : _vm._e(), !_vm.dense ? _c('p', {
    staticClass: "card-description my-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.keyValueText')))]) : _vm._e(), Object.keys(_vm.twinObject.data.keyValue || {}).length === 0 ? _c('core-button', {
    attrs: {
      "data-cy": "btn_add_keyvalue",
      "disabled": !_vm.twinCanBeEdited,
      "title": _vm.$i18n_t('Common.addNew'),
      "color": _vm.color,
      "x-small": _vm.dense,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.addKeyValuePair();
      }
    }
  }) : _vm._e(), _vm._l(Object.keys(_vm.twinObject.data.keyValue || {}), function (key, i) {
    return _c(VRow, {
      key: i,
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "pt-1 pb-1",
      attrs: {
        "cols": "12",
        "sm": _vm.oneColLayout ? undefined : 5
      }
    }, [_c(VTextField, {
      attrs: {
        "disabled": !_vm.twinCanBeEdited || _vm.isCreatedByTemplate && _vm.isTemplatePropertyMandatory(key),
        "data-cy": `input_key_${key}`,
        "value": key,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "dense": _vm.dense,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.key'),
        "hide-details": ""
      },
      on: {
        "change": e => {
          _vm.keyValueKeyChanged(key, e);
        }
      }
    })], 1), _c(VCol, {
      staticClass: "pt-1 pb-1",
      attrs: {
        "cols": "12",
        "sm": _vm.oneColLayout ? undefined : 7
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": `input_value_${key}`,
        "disabled": !_vm.twinCanBeEdited,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "dense": _vm.dense,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.value'),
        "hide-details": "",
        "rules": _vm.isCreatedByTemplate && _vm.isTemplatePropertyMandatory(key) ? [_vm.requiredRule] : undefined
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('core-button', {
            attrs: {
              "title": _vm.$i18n_t('Common.addNew'),
              "color": _vm.color,
              "disabled": !_vm.twinCanBeEdited,
              "x-small": _vm.dense,
              "prepend-icon": "fa-plus",
              "data-cy": "btn_add_keyvalue"
            },
            on: {
              "click": function ($event) {
                return _vm.addKeyValuePair();
              }
            }
          }), !_vm.dense ? [_vm._v(" ")] : _vm._e(), _c(VTooltip, {
            attrs: {
              "right": "",
              "disabled": !_vm.isCreatedByTemplate || !_vm.isTemplatePropertyMandatory(key)
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function ({
                on
              }) {
                return [_c('div', _vm._g({
                  staticStyle: {
                    "display": "inline"
                  }
                }, on), [_c('core-button', {
                  attrs: {
                    "title": _vm.$i18n_t('Common.delete'),
                    "color": _vm.color,
                    "disabled": !_vm.twinCanBeEdited || _vm.isCreatedByTemplate && _vm.isTemplatePropertyMandatory(key),
                    "x-small": _vm.dense,
                    "prepend-icon": "fa-trash-alt"
                  },
                  on: {
                    "click": function ($event) {
                      return _vm.removeKeyValuePair(key);
                    }
                  }
                })], 1)];
              }
            }], null, true)
          }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.customPropertyConfigured', {
            deviceTemplateTitle: _vm.deviceTemplate ? _vm.deviceTemplate.title : null
          })) + "\n          ")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: _vm.twinObject.data.keyValue[key],
        callback: function ($$v) {
          _vm.$set(_vm.twinObject.data.keyValue, key, $$v);
        },
        expression: "twinObject.data.keyValue[key]"
      }
    })], 1)], 1);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };